export default function (context) {
  if(context.ssrContext){
    const { res } = context.ssrContext;
    if (res) {
      res.setHeader('Cache-Control', 'public, max-age=3000');
    }
  }
}